import { render, staticRenderFns } from "./ReportCityMessengerBotSection.vue?vue&type=template&id=7e1ad57c&scoped=true&"
import script from "./ReportCityMessengerBotSection.vue?vue&type=script&lang=js&"
export * from "./ReportCityMessengerBotSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1ad57c",
  null
  
)

export default component.exports
import {QBanner,QIcon,QBtn,QItem,QItemSection,QTooltip} from 'quasar'
component.options.components = Object.assign({QBanner,QIcon,QBtn,QItem,QItemSection,QTooltip}, component.options.components || {})
